import {UIModeSelectorDetailsController, type StartGameCallback, type RedirectToCasualCallback} from '../../../../shared/scripts/ui_html/home_page/UIModeSelectorDetailsController.ts'

export class UIWModeSelectorDetailsController extends UIModeSelectorDetailsController {
    private readonly modeSelectorContainer: HTMLDivElement

    constructor(onStartGame: StartGameCallback, onRedirectToCasual: RedirectToCasualCallback) {
        super(onStartGame, onRedirectToCasual)
        this.modeSelectorContainer = document.getElementById('mm-mode-selector-container') as HTMLDivElement
    }

    protected onShow() {
        this.modeSelectorContainer.classList.add('hidden')
    }

    protected onHide() {
        this.modeSelectorContainer.classList.remove('hidden')
    }
}

